export const ADD_TODO = "ADD_TODO";
export const DELETE_TODO="DELETE_TODO";
export const CLEAR_TODO="CLEAR_TODO";
